import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useRouteError } from "react-router-dom";

import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

function ErrorBoundary(): JSX.Element {
	const { t } = useTranslation();
	const error = useRouteError();

	const emailAddress = "support@trajectx.com";
	const subject = "Unexpected error";

	function hasInformation(): boolean {
		if (error instanceof Error) {
			return error.stack !== undefined;
		}

		return false;
	}

	function getMailContent(): string {
		if (error instanceof Error) {
			let message = `Message:\n${error.message}\n\n`;
			message += `Stacktrace:\n${error.stack}\n\n`;
			return message.replaceAll("\n", "%0D%0A");
		}

		return error as string;
	}

	return (
		<Container>
			<Typography variant="h1">{t("errorPageTitle")}</Typography>
			<Typography variant="body1">{t("errorPageDetails")}</Typography>
			{hasInformation() && (
				<Button
					href={`mailto:${emailAddress}?subject=${subject}&body=${getMailContent()}`}
					variant="contained"
					endIcon={<SendIcon />}>
					{t("sendMail")}
				</Button>
			)}
			<div>
				<Link href="/">{t("goHome")}</Link>
			</div>
		</Container>
	);
}

export default ErrorBoundary;
